import React, { useState, useEffect } from "react";
import JsonData from "../data/data.json";
import { Header } from "../components/header";
import { Navigation } from "../components/navigation";
import { Team } from "../components/Team";
import { Contact } from "../components/contact";

const TeamPage = () => {
  const [data, setData] = useState({});
  useEffect(() => {
    setData(JsonData);
  }, []);
  return (
    <>
      <Header />
      <Navigation />
      <Team data={data.Team} />
      <Contact data={data.Contact} />
    </>
  );
};

export default TeamPage;
